import { useQuery } from "@tanstack/react-query";
import type { Dayjs } from "dayjs";
import { apiGet } from "../api";

export interface DashboardStats {
  counts: {
    categories: number;
    items: number;
    notes: number;
    users: number;
  };
  activity: { date: string; count: number }[];
  system: {
    version: string;
    started_at: Dayjs;
    server_now: Dayjs;
  };
}

export function useDashboardStats(days: number) {
  return useQuery<DashboardStats>({
    queryKey: ["dashboard", "stats", days],
    queryFn: () => apiGet<DashboardStats>(`/dashboard/stats?days=${days}`),
  });
}
